import './instance';
Oskari.bundle('file-layerlist', function () {
  return Oskari.clazz.create('Oskari.file-layerlist.BundleInstance');
});